import htmlElement from "./htmlElements.js";
import defaultWesbsite from "./defaultWebsiteScript.js";

const calendarRoutinr = {
    searchContent(content, month, year) {
        //Search Text
        let searchText = "";

        //Check Object
        if (typeof content === "object") {
            //Content Object
            let contentObj = {};

            //Set Type of Content
            let contentData = Object.getOwnPropertyNames(content);

            //Check Type Of Content
            contentData.forEach((value) => {
                switch (value) {
                    //days, interval
                    case "days":
                    case "interval":
                        //Only get Property
                        contentObj = Object.getOwnPropertyDescriptor(
                            content,
                            value,
                        );

                        //Create a list from value
                        let min = Math.min(...contentObj.value);
                        let max = Math.max(...contentObj.value);

                        searchText = !contentData.includes("recurrent")
                            ? `${min}-${month}-${year} a ${max}-${month}-${year}`
                            : `${content.days}-${month}-${year}`;

                        break;

                    //Customdays
                    case "customdays":
                        searchText = `${content.customdays.join(", ")}-${month}-${year}`;

                        break;

                    //day
                    case "day":
                        searchText = `${content.day}-${month}-${year}`;

                        break;
                }
            });
        }

        return searchText;
    },
    searchContentMultipleMonths(content) {
        if (Array.isArray(content) && content.length > 0) {
            //Get Search Type
            let searchType = "";

            //Search Text
            let searchText = "";

            content.forEach((value, index) => {
                searchType = Object.getOwnPropertyNames(value).find((val) =>
                    this.defaultListOfFilter().includes(val),
                );

                let text = {
                    days: "",
                    month: value.month,
                    year: value.year,
                };

                switch (searchType) {
                    case "week":
                    case "recurrent":
                        text.days = value.days.join(", ");

                        break;

                    case "customdays":
                        text.days = value.customdays.join(", ");

                        break;

                    case "day":
                        text.days = value.day;

                        break;
                }

                switch (index) {
                    case 0:
                        searchText += `${text.days}-${text.month}-${text.year}`;
                        break;

                    default:
                        searchText += ` | ${text.days}-${text.month}-${text.year}`;
                        break;
                }
            });

            return defaultWesbsite.resumeMessage(searchText, 35);
        }
    },
    setHourListValue(interval = 1, begin = 9, ends = 20) {
        //List of Hours
        let hourList = [];
        let turn = [];

        //Set List of Hours
        for (let i = begin; i < ends; i++) {
            turn.push(i * interval);

            if (turn.includes(i)) {
                hourList.push(i);
            }
        }

        return hourList;
    },
    relateHourBySelect(valueList, id) {
        //Append Options
        valueList.forEach((valhour) => {
            let span = htmlElement.createElement(
                "span",
                {
                    data_value: `${valhour}`,
                    class: "hour-option text-center w-100",
                },
                Number.isInteger(parseInt(valhour))
                    ? `${valhour}:00`
                    : `${valhour}`,
            );

            let divspan = htmlElement.createElement("div", {
                data_value: `${valhour}`,
                class: "",
                id: `divspan-${id}-${valhour}`,
            });

            //Append Children
            document.getElementById(`${id}`).appendChild(divspan);
            document
                .getElementById(`divspan-${id}-${valhour}`)
                .appendChild(span);
        });
    },
    createAppendElement(
        typeoflocation,
        baseelement,
        firstselect = "select-turn-morning",
        secondselect = "select-turn-affternoon",
        beginmorning = null,
        beginafternoon = null,
        blockhour = null,
        spanBaseName = "list-btnturn",
    ) {
        //Check Search Type
        switch (typeoflocation) {
            //Location per hour
            case 1:
                //HTML Element Child Base
                let selectOne = htmlElement.createElement("div", {
                    class: "selectturn",
                    data_action: "hour",
                    id: firstselect,
                    style: "",
                });

                let selectTwo = htmlElement.createElement("div", {
                    class: "selectturn",
                    data_action: "hour",
                    id: secondselect,
                    style: "",
                });

                //Html Separate List from Refer Value
                let firstDivBaseReferValue = htmlElement.createElement("div", {
                    id: `firstdivbaserefervalue-${firstselect}`,
                    data_action: "hour",
                    class: "firstdivbaserefervalue",
                });

                let SecondDivBaseReferValue = htmlElement.createElement("div", {
                    id: `seconddivbaserefervalue-${secondselect}`,
                    data_action: "hour",
                    class: "seconddivbaserefervalue",
                });

                let firstDivBaseValueList = htmlElement.createElement("div", {
                    id: `firstdivbasevaluelist-${firstselect}`,
                    class: "firstdivbasevaluelist d-none",
                });

                let SecondDivBaseValueList = htmlElement.createElement("div", {
                    id: `seconddivbasevaluelist-${secondselect}`,
                    class: "seconddivbasevaluelist d-none",
                });

                //Html Element Input Base
                let firstDivSelectOne = htmlElement.createElement("div", {
                    id: `firstdivchild-${firstselect}`,
                    class: "d-flex flex-row justify-content-center",
                });

                let secondDivSelectTwo = htmlElement.createElement("div", {
                    id: `seconddivchild-${secondselect}`,
                    class: "d-flex flex-row justify-content-center",
                });

                let firstDivSelectOneReferValue = htmlElement.createElement(
                    "div",
                    {
                        id: `firstdivrefervalue-${firstselect}`,
                        data_action: "hour",
                        class: "firstdivrefervalue",
                    },
                );

                let secondDivSelectTwoReferValue = htmlElement.createElement(
                    "div",
                    {
                        id: `secondrefervalue-${secondselect}`,
                        data_action: "hour",
                        class: "secondrefervalue",
                    },
                );

                //Create Basic Element Child
                let spanDivSelectOne = htmlElement.createElement(
                    "span",
                    {
                        data_value: "nohour",
                        class: "hour-option select",
                    },
                    "Inicio",
                );

                let spanDivSelectTwo = htmlElement.createElement(
                    "span",
                    {
                        data_value: "nohour",
                        class: "hour-option select",
                    },
                    "Fim",
                );

                let spanDivSelectOneValueRefer = htmlElement.createElement(
                    "span",
                    {
                        class: "refer-value",
                        data_action: "hour",
                        id: `refer-value-${firstselect}`,
                    },
                    "Inicio",
                );

                let spanDivSelectTwoValueRefer = htmlElement.createElement(
                    "span",
                    {
                        class: "refer-value",
                        data_action: "hour",
                        id: `refer-value-${secondselect}`,
                    },
                    "Fim",
                );

                //Set Value for Select
                let valueList = this.setHourListValue(1, 9, 19);

                //Append Select Children
                document
                    .querySelector(`.${baseelement}`)
                    .appendChild(selectOne);
                document
                    .querySelector(`.${baseelement}`)
                    .appendChild(selectTwo);

                //Append Refer Div and Value List Div
                document
                    .getElementById(`${firstselect}`)
                    .appendChild(firstDivBaseReferValue);
                document
                    .getElementById(`${secondselect}`)
                    .appendChild(SecondDivBaseReferValue);
                document
                    .getElementById(`${firstselect}`)
                    .appendChild(firstDivBaseValueList);
                document
                    .getElementById(`${secondselect}`)
                    .appendChild(SecondDivBaseValueList);

                //Append Basic Div Elements
                document
                    .getElementById(`firstdivbaserefervalue-${firstselect}`)
                    .appendChild(firstDivSelectOneReferValue);
                document
                    .getElementById(`seconddivbaserefervalue-${secondselect}`)
                    .appendChild(secondDivSelectTwoReferValue);
                //document.getElementById(`firstdivbasevaluelist-${firstselect}`).appendChild(firstDivSelectOne);
                //document.getElementById(`seconddivbasevaluelist-${secondselect}`).appendChild(secondDivSelectTwo);

                //Append Basic Spans Info
                document
                    .getElementById(`firstdivrefervalue-${firstselect}`)
                    .appendChild(spanDivSelectOneValueRefer);
                document
                    .getElementById(`secondrefervalue-${secondselect}`)
                    .appendChild(spanDivSelectTwoValueRefer);
                //document.getElementById(`firstdivchild-${firstselect}`).appendChild(spanDivSelectOne);
                //document.getElementById(`seconddivchild-${secondselect}`).appendChild(spanDivSelectTwo);

                //Append Options
                this.relateHourBySelect(
                    valueList,
                    `firstdivbasevaluelist-${firstselect}`,
                );
                this.relateHourBySelect(
                    valueList,
                    `seconddivbasevaluelist-${secondselect}`,
                );

                break;

            //trabalhar aqui global
            //Location per period
            case 2:
                //Base Button Elements
                let divSelect = htmlElement.createElement("div", {
                    class: "select-btnturn",
                    id: "select-btnturn",
                    data_action: "period",
                });

                //Append Base Button Elements
                document
                    .querySelector(`.${baseelement}`)
                    .appendChild(divSelect);

                //Span Base
                let spanBase = htmlElement.createElement(
                    "span",
                    {
                        class: "list-btnturn d-flex flex-row justify-content-between",
                        role: "button",
                        id: spanBaseName,
                        data_action: "list",
                    },
                    "Período",
                );

                //Span Base Elements
                let divSelectSpanBase = htmlElement.createElement("div", {
                    class: "base-btnturn d-none flex-column",
                    id: "base-btnturn",
                    role: "list",
                    data_action: "period",
                });

                //Append Base Button Elements
                divSelect.appendChild(spanBase);
                divSelect.appendChild(divSelectSpanBase);

                //Span Child HTML Element
                let spanOne = htmlElement.createElement(
                    "span",
                    {
                        class: "btnturn spanOne button-body d-flex flex-column",
                        role: "button",
                        data_value: 1,
                        data_action: "period",
                    },
                    "Manhã",
                );

                let spanTwo = htmlElement.createElement(
                    "span",
                    {
                        class: "btnturn button-body d-flex flex-column",
                        role: "button",
                        data_value: 2,
                        data_action: "period",
                    },
                    "Tarde",
                );

                let spanThree = htmlElement.createElement(
                    "span",
                    {
                        class: "btnturn button-body d-flex flex-column",
                        role: "button",
                        data_value: 3,
                        data_action: "period",
                    },
                    "Dia Inteiro",
                );

                //Append Children
                divSelectSpanBase.appendChild(spanOne);
                divSelectSpanBase.appendChild(spanTwo);
                divSelectSpanBase.appendChild(spanThree);

                //Small Child HTML Element

                let beginMorning = beginmorning !== null ? beginmorning : "9";
                let endMorning =
                    beginmorning !== null && blockhour !== null
                        ? parseInt(beginmorning) + parseInt(blockhour)
                        : "13";
                let beginAfternoon =
                    beginafternoon !== null ? beginafternoon : "14";
                let endAfternoon =
                    beginafternoon !== null && blockhour !== null
                        ? parseInt(beginafternoon) + parseInt(blockhour)
                        : "18";
                let beginAllday = beginMorning;
                let endAllday = endAfternoon;

                let smallOne = htmlElement.createElement(
                    "small",
                    {
                        class: "btnturn-content color-text-body caption-md",
                        role: "button",
                        data_value: 1,
                        data_action: "period",
                    },
                    `Das ${beginMorning}:00 às ${endMorning}:00`,
                );

                let smallTwo = htmlElement.createElement(
                    "small",
                    {
                        class: "btnturn-content color-text-body caption-md",
                        role: "button",
                        data_value: 2,
                        data_action: "period",
                    },
                    `Das ${beginAfternoon}:00 às ${endAfternoon}:00`,
                );

                let smallThree = htmlElement.createElement(
                    "small",
                    {
                        class: "btnturn-content color-text-body caption-md",
                        role: "button",
                        data_value: 3,
                        data_action: "period",
                    },
                    `Das ${beginAllday}:00 às ${endAllday}:00`,
                );

                //Append Children
                spanOne.appendChild(smallOne);
                spanTwo.appendChild(smallTwo);
                spanThree.appendChild(smallThree);

                break;
        }
    },
    selectDaysFromSearchType(
        searchtype,
        tdParentElement,
        spanElement,
        daysElementsList,
        interval,
        customDays,
        selectDaysList = [],
    ) {
        //Filter Object
        let filter = {};

        //Set Month
        filter.month = parseInt(tdParentElement.getAttribute("data-month"));

        //Set Year
        filter.year = parseInt(tdParentElement.getAttribute("data-year"));

        //Routine by Search Type
        if ([3, 4, 5].includes(parseInt(searchtype))) {
            filter.action = "push";
        }

        //Select Days from Search Type
        switch (parseInt(searchtype)) {
            //Unique Day
            case 1:
                //Select Day Logic - Remove Class
                this.cleanSelectDateClass(daysElementsList);

                //Select Day Logic - Remove Class for all Months
                this.cleanSelectDateClass([
                    ...document.querySelectorAll(".weekday"),
                ]);

                //Select Day Logic
                let getDay = daysElementsList.find(
                    (value) => tdParentElement === value,
                );

                if (getDay !== undefined) {
                    if (Number.isInteger(parseInt(spanElement.textContent))) {
                        //Add Class
                        spanElement.classList.add("selectday");

                        //Set Day For Search
                        filter.day = parseInt(spanElement.textContent);
                    }
                }

                break;

            //Semana, Recorrente
            case 2:
            case 5:
                //Select Day Logic - Remove Class
                this.cleanSelectDateClass(daysElementsList);

                //Set type of Data
                let typeofdata = "";

                switch (parseInt(searchtype)) {
                    //Semana
                    case 2:
                        typeofdata = "data-week";
                        filter.week = parseInt(
                            tdParentElement.getAttribute("data-week"),
                        );

                        //Select Day Logic - Remove Class for all Months
                        this.cleanSelectDateClass([
                            ...document.querySelectorAll(".weekday"),
                        ]);

                        break;

                    //Recorrente
                    case 5:
                        typeofdata = "data-weekdaynumber";
                        filter.recurrent = parseInt(
                            tdParentElement.getAttribute("data-weekdaynumber"),
                        );
                        //Check if the month already exist in selectDaysList
                        this.checkSelectListConditionalByMonth(
                            selectDaysList,
                            filter,
                        );

                        break;
                }

                //Get Week
                let week = daysElementsList.filter((value) => {
                    if (
                        tdParentElement.getAttribute(typeofdata) ===
                            value.getAttribute(typeofdata) &&
                        !value.classList.contains("disabledclick") &&
                        value.firstElementChild.textContent !== "" &&
                        Number.isInteger(
                            parseInt(value.firstElementChild.textContent),
                        )
                    ) {
                        //Get All Days of Week
                        return value;
                    }
                });

                //Check Week Select
                if (week.length > 0) {
                    //Set Filter Select
                    filter.days = [];

                    //Select All Days from Week
                    week.forEach((value) => {
                        //Add Class
                        value.firstElementChild.classList.add("selectday");

                        //Set Days from Week
                        filter.days.push(
                            parseInt(value.firstElementChild.textContent),
                        );
                    });

                    filter.days.join(", ");
                }

                break;

            //Intervalo de Dias
            case 3:
                //Select Day Logic - Remove Class
                this.cleanSelectDateClass(daysElementsList);

                //Select Day Logic - Remove Class for all Months
                this.cleanSelectDateClass([
                    ...document.querySelectorAll(".weekday"),
                ]);

                //Check Data Type
                if (!Number.isInteger(parseInt(spanElement.textContent))) {
                    return;
                }

                //Push Interval Date
                if (interval.length === 0) {
                    interval.push(parseInt(spanElement.textContent));
                } else {
                    //Check if the value exist
                    if (interval.length < 2) {
                        interval.push(parseInt(spanElement.textContent));
                    } else {
                        //Get Index
                        let index = interval.indexOf(
                            parseInt(spanElement.textContent),
                        );

                        //Check Old Values
                        if (
                            interval.includes(parseInt(spanElement.textContent))
                        ) {
                            //Remove value
                            interval.splice(index, 1);
                        } else {
                            //Sort Values
                            interval = interval.sort((a, b) => a - b);

                            //Minest Day
                            let min = Math.min(interval[0], interval[1]);

                            //Biggest Day
                            let max = Math.max(interval[0], interval[1]);

                            //Check the minor value and the biggest value
                            interval[0] =
                                (parseInt(spanElement.textContent) > min &&
                                    parseInt(spanElement.textContent) < max) ||
                                parseInt(spanElement.textContent) < min
                                    ? parseInt(spanElement.textContent)
                                    : min;
                            interval[1] =
                                parseInt(spanElement.textContent) > max
                                    ? parseInt(spanElement.textContent)
                                    : max;
                        }
                    }
                }

                //Set Interval of Days
                let intervalOfDaysByIndex = daysElementsList.filter(
                    (value, index) =>
                        interval.includes(
                            parseInt(value.firstElementChild.textContent),
                        ),
                );

                //First Scenario only start day
                if (intervalOfDaysByIndex.length === 1) {
                    //Add class
                    intervalOfDaysByIndex[0].firstElementChild.classList.add(
                        "selectday",
                    );
                } else {
                   
                    //Interval of Day List
                    let intervalOfDaysList = [];

                    //Filter days without disabledclick
                    daysElementsList = daysElementsList.filter((value) => !value.classList.contains('disabledclick'));

                    //Get Index From Element
                    let startElement = daysElementsList.indexOf(
                        intervalOfDaysByIndex[0],
                    );
                    let endElement = daysElementsList.indexOf(
                        intervalOfDaysByIndex[1],
                    );

                    //Index From Elements Loop
                    for (let i = 0; i < daysElementsList.length; i++) {
                        if (i >= startElement && i <= endElement) {
                            //Add Class
                            daysElementsList[i].firstElementChild.classList.add(
                                "selectday",
                            );

                            //Push Days
                            intervalOfDaysList.push(
                                parseInt(
                                    daysElementsList[i].firstElementChild
                                        .textContent,
                                ),
                            );
                        }
                    }

                    //Assign Interval of Days
                    filter.interval = intervalOfDaysList;
                }

                break;

            //Personalizado
            case 4:
                //Check Data Type
                if (!Number.isInteger(parseInt(spanElement.textContent))) {
                    return;
                }

                //Select Day Logic
                if (customDays.length === 0) {
                    //Add Class
                    spanElement.classList.add("selectday");

                    //Push Day
                    customDays.push(parseInt(spanElement.textContent));
                } else {
                    //Check value
                    if (
                        !customDays.includes(parseInt(spanElement.textContent))
                    ) {
                        //Add Class
                        spanElement.classList.add("selectday");

                        //Push Day
                        customDays.push(parseInt(spanElement.textContent));
                    } else {
                        //Get Index
                        let index = customDays.indexOf(
                            parseInt(spanElement.textContent),
                        );

                        //Remove day from list
                        customDays.splice(index, 1);

                        //Remove Class
                        spanElement.classList.remove("selectday");
                    }
                }

                //Set Personalized Day For Search
                filter.customdays =
                    customDays.length > 0
                        ? customDays.sort((a, b) => a - b)
                        : customDays;

                //Check if the month already exist in selectDaysList
                this.checkSelectListConditionalByMonth(selectDaysList, filter);

                break;
        }

        return filter;
    },
    setHourOrPeriod(reserve, element) {
        //Check Data Action
        if (!element.hasAttribute("data-action")) {
            return reserve;
        }

        //Check Element
        switch (element.getAttribute("data-action")) {
            //Per Hour
            case "hour":
                //Clean Old Values
                reserve.data = {};

                //Set Data from Turn
                reserve.type = "hour";

                //Get Div List
                let divList = "";
                let baseSelectElement = "";

                //Check Element Type
                switch (element.nodeName) {
                    case "DIV":
                        divList = element.lastElementChild;
                        baseSelectElement = element;

                        //Confirm Base List
                        if (divList.nodeName === "SPAN") {
                            divList =
                                divList.parentElement.parentElement
                                    .nextElementSibling;
                        }

                        break;

                    case "SPAN":
                        divList =
                            element.parentElement.parentElement
                                .nextElementSibling;
                        baseSelectElement =
                            element.parentElement.parentElement.parentElement;

                        break;
                }

                //Show or Hide
                if (divList.classList.contains("d-none")) {
                    divList.classList.remove("d-none");
                    baseSelectElement.style = "";
                } else {
                    divList.classList.add("d-none");
                    //baseSelectElement.style = "max-height:3rem;";
                }

                //Hide ReferValue Element
                //divList.previousElementSibling.style.visibility = 'hidden';
                //divList.previousElementSibling.classList.add('d-none');
                //document.getElementById(`refer-value-${divList.getAttribute('id')}`).classList.add('d-none');

                let firstchildrenrefervalue = [
                    ...divList.previousElementSibling.children,
                ];
                [...firstchildrenrefervalue[0].children].forEach((value) =>
                    value.classList.add("d-none"),
                );

                //console.log(divList);

                //Select Data from Hour or Turn
                divList.addEventListener("click", function (e) {
                    //Get Data Value
                    let dataValue = Number.isInteger(
                        parseInt(e.target.getAttribute("data-value")),
                    )
                        ? parseInt(e.target.getAttribute("data-value"))
                        : null;
                    let typeOfPrimaryValue = "";

                    switch (divList.getAttribute("id")) {
                        case `firstdivbasevaluelist-${baseSelectElement.getAttribute("id")}`:
                            //Set Value
                            reserve.datahour.begin = dataValue;
                            typeOfPrimaryValue = "Inicio";

                            break;

                        case `seconddivbasevaluelist-${baseSelectElement.getAttribute("id")}`:
                            //Set Value
                            reserve.datahour.end = dataValue;
                            typeOfPrimaryValue = "Fim";

                            break;
                    }

                    //console.log(dataValue);
                    //console.log(baseSelectElement.getAttribute('id'));

                    //Hide Select
                    this.classList.add("d-none");
                    //baseSelectElement.style = "max-height:3rem;";

                    //Change TextContent from refer value
                    if (
                        document.getElementById(
                            `refer-value-${baseSelectElement.getAttribute("id")}`,
                        )
                    ) {
                        document.getElementById(
                            `refer-value-${baseSelectElement.getAttribute("id")}`,
                        ).textContent =
                            dataValue !== null
                                ? `${dataValue}:00`
                                : typeOfPrimaryValue;
                    }

                    //Show ReferValue Element
                    //divList.previousElementSibling.style.visibility = 'visible';
                    //divList.previousElementSibling.classList.remove('d-none');
                    //document.getElementById(`refer-value-${divList.getAttribute('id')}`).classList.remove('d-none')
                    [...firstchildrenrefervalue[0].children].forEach((value) =>
                        value.classList.remove("d-none"),
                    );

                    return reserve;
                });

                //console.log(reserve.datahour);

                break;

            //Per Period
            case "period":
                //Clean Old Values
                reserve.data = {};

                //Clean Old Values
                reserve.datahour = {
                    begin: "",
                    end: "",
                };

                //Set Data from Turn
                reserve.type = "turn";

                //Set Value
                reserve.data = parseInt(element.getAttribute("data-value"));

                //Check Element
                let classBase =
                    element.nodeName === "SPAN"
                        ? ".btnturn"
                        : ".btnturn-content";

                //Get the sibling element
                [...document.querySelectorAll(classBase)].forEach((value) => {
                    //Check Element
                    let baseElement =
                        element.nodeName === "SPAN"
                            ? value
                            : value.parentElement;

                    //Remove all class
                    baseElement.classList.remove("active");

                    //Set Class
                    if (element === value) {
                        //Active Button
                        !baseElement.classList.contains("active")
                            ? baseElement.classList.add("active")
                            : baseElement.classList.remove("active");

                        //Hide List
                        baseElement.parentElement.classList.remove("d-flex");
                        baseElement.parentElement.classList.add("d-none");

                        //Identify action
                        baseElement.parentElement.previousElementSibling.classList.remove(
                            "show-list",
                        );
                        baseElement.parentElement.previousElementSibling.classList.add(
                            "hide-list",
                        );
                    }
                });

                break;
        }

        return reserve;
    },
    checkValuesBeforeSend(
        begin,
        end,
        baseSelectElementOne,
        baseSelectElementTwo,
    ) {
        //Check per empty values
        if (Number.isInteger(begin) && Number.isInteger(end)) {
            //Add Check Conditional for Hour Error
            if (end <= begin || end === begin) {
                //Clean Old Values
                document.getElementById(
                    `refer-value-${baseSelectElementOne}`,
                ).textContent = "Inicio";
                document.getElementById(
                    `refer-value-${baseSelectElementTwo}`,
                ).textContent = "Fim";

                return false;
            }

            return true;
        }

        return false;
    },
    setBookingDetails(
        subtotalvalue,
        subtotal,
        day,
        begin,
        end,
        selectday,
        total,
        editbtn = true,
        available = true,
        month = null,
        year = null,
    ) {
        //Add No available class
        let notAvailableClass = !available ? "noavailable" : "";

        //Create Li Elemet
        let li = htmlElement.createElement("li", {
            class: `list-group-item ${notAvailableClass}`,
            aria_describedby: "booking details",
            data_day: `${selectday}`,
            data_totalhour: `${total}`,
            data_total: `${subtotalvalue}`,
            data_month: month,
            data_year: year,
        });

        //Create First Div Element
        let firstdiv = htmlElement.createElement("div", {
            class: "flex-wrapper-class",
        });

        //Create Second Div Element
        let seconddiv = htmlElement.createElement("div", {
            class: "flex-wrapper-class",
        });

        //Create First Div Child Content - Date
        let datecontent = htmlElement.createElement(
            "p",
            {
                class: "datecontent-pdp-details m-0",
                data_day: `${selectday}`,
            },
            `${day}`,
        );

        //Create First Div Child Content - Hour
        let hourcontent = htmlElement.createElement(
            "p",
            {
                class: "hourcontent-pdp-details m-0",
                data_totalhour: `${total}`,
            },
            `${begin}:00 - ${end}:00`,
        );

        //Create Second Div Child Content - TotalDiv
        let totaldiv = htmlElement.createElement("div", {
            class: "totalcontent-pdp-details-wrapper",
        });

        //Create Second Div Child Content - Total
        let totalcontent = htmlElement.createElement(
            "p",
            {
                class: "totalcontent-pdp-details m-0",
                data_total: `${subtotalvalue}`,
            },
            `Total: ${subtotal} `,
        );

        //Create Second Div Child Content - Total Hour
        let totalhourcontent = htmlElement.createElement(
            "small",
            {
                class: "totalhourcontent-pdp-details caption-md m-0",
            },
            `/ ${total} horas`,
        );

        //Create Second Div Child Content - Edit Button
        let editdetails = htmlElement.createElement(
            "span",
            {
                class: "edit-pdp-details body-1 m-0",
                role: "button",
                data_day: `${selectday}`,
                data_totalhour: `${total}`,
                data_total: `${subtotalvalue}`,
                data_month: month,
                data_year: year,
            },
            "edit",
        );

        //Append First Div Content
        firstdiv.appendChild(datecontent);
        firstdiv.appendChild(hourcontent);

        //Append Second Div Content
        totalcontent.appendChild(totalhourcontent);
        totaldiv.appendChild(totalcontent);
        seconddiv.appendChild(totaldiv);

        //Append Edit Btn
        if (editbtn) {
            seconddiv.appendChild(editdetails);
        }

        //Append Divs
        li.appendChild(firstdiv);
        li.appendChild(seconddiv);

        return li;
    },
    defaultListOfFilter() {
        return ["day", "week", "interval", "customdays", "recurrent"];
    },
    cleanSelectDateClass(daysElementsList, classname = "selectday") {
        //Select Day Logic - Remove Class
        daysElementsList.forEach((value) => {
            //Remove Class
            value.firstElementChild.classList.remove(classname);
        });
    },
    checkSelectListConditionalByMonth(selectDaysList, filter) {
        if (selectDaysList.length > 0) {
            //Confirm month
            let confirmMonth = selectDaysList.find((value) =>
                Object.is(value.month, filter.month),
            );

            if (confirmMonth !== undefined) {
                //Routine
                filter.action = "map";
            }
        }
    },
    getAllElementsDayFromMonthCalendar(
        calendarelement,
        dayclassname = "weekday",
    ) {
        //Get All Td Values
        let daysElementMonthList = [];

        calendarelement.forEach((value) => {
            if (value.nodeName === "TBODY") {
                [...value.children].forEach((val) => {
                    [...val.children].forEach((valday) => {
                        if (valday.classList.contains(dayclassname)) {
                            daysElementMonthList.push(valday);
                        }
                    });
                });
            }
        });

        return daysElementMonthList;
    },
    calendarNavigation(
        element,
        currentYear,
        nextYear,
        currentMonth,
        elReferYear,
        elReferMonth,
        calendarcontainerclassname = "calendar-container",
        calendarmonthbaseclassname = "calendar-month-base",
    ) {
        //Check type of element
        if (!element.hasAttribute("data-action")) {
            return;
        }

        let referMonth = parseInt(element.getAttribute("data-monthrefer"));
        let referYear = parseInt(element.getAttribute("data-yearrefer"));
        let changeCalendarCond = true;

        switch (element.getAttribute("data-action")) {
            case "next":
                changeCalendarCond =
                    referMonth <= 13 &&
                    [currentYear, nextYear].includes(referYear);

                break;

            case "prev":
                changeCalendarCond =
                    referMonth <= 12 &&
                    [currentYear, nextYear].includes(referYear);

                break;
        }

        if (changeCalendarCond) {
            //Calendar Container by Year
            switch (referYear) {
                case currentYear:
                    if (
                        document
                            .getElementById(
                                `${calendarcontainerclassname}-${currentYear}`,
                            )
                            .classList.contains("d-none")
                    ) {
                        document
                            .getElementById(
                                `${calendarcontainerclassname}-${currentYear}`,
                            )
                            .classList.remove("d-none");
                        document
                            .getElementById(
                                `${calendarcontainerclassname}-${nextYear}`,
                            )
                            .classList.add("d-none");
                    }

                    break;

                case nextYear:
                    if (
                        document
                            .getElementById(
                                `${calendarcontainerclassname}-${nextYear}`,
                            )
                            .classList.contains("d-none")
                    ) {
                        document
                            .getElementById(
                                `${calendarcontainerclassname}-${nextYear}`,
                            )
                            .classList.remove("d-none");
                        document
                            .getElementById(
                                `${calendarcontainerclassname}-${currentYear}`,
                            )
                            .classList.add("d-none");
                    }

                    break;
            }

            //Hide Current Month Calendar
            document
                .getElementById(
                    `${calendarmonthbaseclassname}-${elReferYear}-${elReferMonth}`,
                )
                .classList.add("d-none");

            let monthContainer = [
                ...document.querySelectorAll(
                    `.${calendarmonthbaseclassname}-${elReferYear}`,
                ),
            ].find(
                (value) =>
                    parseInt(value.getAttribute("data-monthrefer")) ===
                        referMonth &&
                    parseInt(value.getAttribute("data-yearrefer")) ===
                        referYear,
            );

            switch (referMonth) {
                case 0:
                    document
                        .getElementById(
                            `${calendarmonthbaseclassname}-${currentYear}-12`,
                        )
                        .classList.remove("d-none");

                    break;

                case 13:
                    document
                        .getElementById(
                            `${calendarmonthbaseclassname}-${nextYear}-1`,
                        )
                        .classList.remove("d-none");

                    break;

                default:
                    if (monthContainer !== undefined) {
                        monthContainer.classList.remove("d-none");
                    }

                    break;
            }
        }
    },
    dynamicStrucutureForSelectDaysFromSearchType(
        searchdata,
        tdParentElement,
        spanElement,
        daysElementMonthList,
        interval,
        customDays,
        btnclassname = "btnselectday",
        routine = "filter",
    ) {
        //Select Days from Search Type
        switch (searchdata.searchtype) {
            //Unique Day, week and Interval of days
            case 1:
            case 2:
            case 3:
                searchdata[routine] = this.selectDaysFromSearchType(
                    searchdata.searchtype,
                    tdParentElement,
                    spanElement,
                    daysElementMonthList,
                    interval,
                    customDays,
                );

                //List of Filter for Enable Button
                this.defaultListOfFilter().forEach((value) => {
                    if (Object.hasOwn(searchdata[routine], value)) {
                        //Enabled BTN
                        document
                            .querySelector(`.${btnclassname}`)
                            .removeAttribute("disabled");
                    }
                });

                break;

            //Customize and Recorrency
            case 4:
            case 5:
                let response = this.selectDaysFromSearchType(
                    searchdata.searchtype,
                    tdParentElement,
                    spanElement,
                    daysElementMonthList,
                    interval,
                    customDays,
                    searchdata.filterbymonth,
                );

                //Action Routine
                switch (response.action) {
                    //Push
                    case "push":
                        searchdata.filterbymonth.push(response);

                        break;

                    //Map
                    case "map":
                        searchdata.filterbymonth.map((value) => {
                            if (
                                Object.is(
                                    value.month,
                                    parseInt(
                                        tdParentElement.getAttribute(
                                            "data-month",
                                        ),
                                    ),
                                )
                            ) {
                                switch (searchdata.searchtype) {
                                    //Recorrency and Customize
                                    case 5:
                                    case 4:
                                        Object.assign(value, response);
                                        break;
                                }
                            }
                        });

                        break;
                }

                //Enable Btn Routine
                searchdata.filterbymonth.forEach((value) => {
                    let filterauth = Object.getOwnPropertyNames(value).find(
                        (val) => this.defaultListOfFilter().includes(val),
                    );

                    if (filterauth !== undefined) {
                        //Enabled BTN
                        document
                            .querySelector(`.${btnclassname}`)
                            .removeAttribute("disabled");
                    }
                });

                break;
        }
    },
    showHideTurnList(element) {
        if (element.nextElementSibling.classList.contains("d-none")) {
            //Show List
            element.nextElementSibling.classList.remove("d-none");
            element.nextElementSibling.classList.add("d-flex");

            //Identify action
            element.classList.add("show-list");
            element.classList.remove("hide-list");
        } else {
            element.nextElementSibling.classList.remove("d-flex");
            element.nextElementSibling.classList.add("d-none");

            //Identify action
            element.classList.remove("show-list");
            element.classList.add("hide-list");
        }
    },
    dynamicUpdateSelectTurnId(element, idname = "list-btnturn") {
        //Get Element
        if (
            element.hasAttribute("data-action") &&
            element.getAttribute("data-action") === "period"
        ) {
            let elementBase =
                element.nodeName === "SPAN" ? element : element.parentElement;
            document.getElementById(idname).textContent =
                elementBase.firstChild.textContent;
        }

    },
    removeActiveClassFromBtnTurn(classname = 'basebtnturn', referclassname = 'base-btnturn'){

        [...document.querySelector(`.${classname}`).children].forEach((value) => {

            [...value.children].forEach((val) => {

                if(val.classList.contains(referclassname)){

                    [...val.children].forEach((valchildren) => valchildren.classList.remove('active'));

                }

            });

        });

    }

};

export default calendarRoutinr;
